import { PRODUCT_NAMES } from './product-names.js';
/** Display labels for `deviceCategory` values (internal keys unchanged). */
export const DEVICE_CATEGORY_LABELS = {
    'efem-gateway': PRODUCT_NAMES.AXON,
    'location-gateway': PRODUCT_NAMES.MATRIX,
    'location-tag': PRODUCT_NAMES.NODE,
    'location-anchor': PRODUCT_NAMES.SATELLITE,
    'barcode-scanner': PRODUCT_NAMES.AXON_BARCODE_MODULE,
    'handheld-barcode-scanner': PRODUCT_NAMES.AXON_HANDHELD_BARCODE,
    'waferid-camera': PRODUCT_NAMES.AXON_WAFER_ID_MODULE,
    'multi-gateway': 'Multi-Gateway',
    unknown: 'Device',
};
export function getDeviceCategoryLabel(category) {
    if (!category) {
        return DEVICE_CATEGORY_LABELS.unknown;
    }
    return DEVICE_CATEGORY_LABELS[category] ?? category;
}
/** Short labels for filter dropdowns (may include parenthetical hints). */
export const DEVICE_CATEGORY_FILTER_LABELS = {
    ...DEVICE_CATEGORY_LABELS,
    'location-tag': `${PRODUCT_NAMES.NODE} (UWB)`,
    'location-anchor': `${PRODUCT_NAMES.SATELLITE} (UWB)`,
};
export function getDeviceCategoryFilterLabel(category) {
    return DEVICE_CATEGORY_FILTER_LABELS[category] ?? getDeviceCategoryLabel(category);
}
export const NON_IOT_DEVICE_CATEGORIES = [
    'location-tag',
    'location-anchor',
    'barcode-scanner',
    'handheld-barcode-scanner',
    'waferid-camera',
];
export function isNonIotDeviceCategory(category) {
    if (!category)
        return false;
    return NON_IOT_DEVICE_CATEGORIES.includes(category);
}
const IOT_DEVICE_CATEGORIES = [
    'efem-gateway',
    'location-gateway',
    'multi-gateway',
];
/** Select options for device fleet filters and forms. */
export function getDeviceCategorySelectOptions(categories = [...IOT_DEVICE_CATEGORIES, ...NON_IOT_DEVICE_CATEGORIES]) {
    return categories.map((value) => ({
        value,
        label: getDeviceCategoryFilterLabel(value),
    }));
}
/** Plural labels for order quantity rows. */
export function getDeviceCategoryOrderLabel(category) {
    const singular = getDeviceCategoryLabel(category);
    if (singular.endsWith('Module')) {
        return `${singular}s`;
    }
    if (singular.startsWith('Cnapse ')) {
        return `${singular}s`;
    }
    return singular;
}
//# sourceMappingURL=device-category-labels.js.map